import { splitProps } from 'solid-js';
import style from '#src/client/common/boxes/SideBox.module.css';

const sizes = {
    small: '8px',
    default: '16px', // will be used if nothing is specified
    large: '32px',
};

const colors = {
    primary: {
        border: `var(--primary)`,
        content: `var(--primarySuperLight)`,
    },
    gray: {
        border: `var(--gray)`,
        content: `var(--graySuperLight)`,
    },
    alt: {
        border: `var(--alt)`,
        content: `var(--altSuperLight)`,
    },
    purple: {
        border: `var(--purple)`,
        content: `var(--purpleSuperLight)`,
    },
    subdued: {
        border: `var(--subdued)`,
        content: `var(--subduedSuperLight)`,
    },
    positive: {
        border: `var(--positive)`,
        content: `var(--positiveSuperLight)`,
    },
    negative: {
        border: `var(--negative)`,
        content: `var(--negativeSuperLight)`,
    },
    warning: {
        border: `var(--warning)`,
        content: `var(--warningSuperLight)`,
    },
};

const colorKeys = Object.keys(colors);

function SideBox(props) {
    const [local, others] = splitProps(props, [
        'borderColor',
        'contentColor',
        'size',
        'hasError',
        'class',
    ]);

    const getSize = () => {
        const size = local.size || 'default';
        return sizes[size] ?? size;
    };

    const getBorderColor = () => {
        const color = local.borderColor || 'primary';

        if (colorKeys.includes(color)) {
            return colors[color].border;
        }

        // Manually specified css color.
        return color;
    };

    const contentColor = () => {
        // If nothing is specified, will default to the SuperLight color of the borderColor, or white if the borderColor is not a known color.
        if (!local.contentColor) {
            const borderColor = local.borderColor || 'primary';

            if (colorKeys.includes(borderColor)) {
                return colors[borderColor].content;
            }

            return colors.gray.content;
        }

        if (colorKeys.includes(local.contentColor)) {
            return colors[local.contentColor].content;
        }

        // Manually specified css color.
        return local.contentColor;
    };

    const classes = () => {
        return [
            local.class,
            style.sideBoxBorder,
            local.hasError ? style.hasError : '',
        ].join(' ');
    };

    return (
        <div {...others} class={classes()} style={{ '--sideBoxBorderColor': getBorderColor(), '--size': getSize() }}>
            <div class={style.sideBoxContent} style={{ '--sideBoxContentColor': contentColor() }}>
                {props.children}
            </div>
        </div>
    );
}

export default SideBox;